import { PROMOTION_ROUTE_NAME } from '@/libs/route-name';

export const promotionRoute = () => {
  return {
    name: PROMOTION_ROUTE_NAME.PROMOTION,
    path: '/promotion',
    component: () => import('@/pages/promotion/index.vue'),
  };
};

